const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB w36 ` + (props.className || '')}
    >
      <path d="m0 0h80v80h-80z" fill="#0ee06e"/>
      <path
        d="m13.4296 37.7h18.2915v-14.4698l14.6559 14.4698-14.6559 14.3577v7.4032h17.7234v-21.7609h16.3601v-17.0497h-52.375z"
        fill="#000"/>
    </svg>
  );
};
